import React from 'react';
import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import PhoneEnabledIcon from '@material-ui/icons/PhoneEnabled';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import { purple, green, red, blue, indigo, teal } from '@material-ui/core/colors';
import CustomButton from './CustomButton';

// スタイルを定義
const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      padding: theme.spacing(2),
      flexGrow: 1,
    },
  })
);

function Corporation() {
  const classes = useStyles();

  return (
    <div className={classes.root}>
      <div className="wraper">

        <a id="ad-newspaper" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            新聞広告
          </Typography>
          　デーリー東北は、戦後間もない１９４５(昭和２０)年に創刊しました。本社のある八戸市を中心に、青森県をタテ半分に割った太平洋側と岩手県北をカバーしています。地方紙でありながらエリアが２県にまたがる全国でも珍しい新聞社です。２０２１(令和３)年現在、約９万２千部を発行し、特に八戸市内では、新聞を購読している世帯の８０％以上にご愛読いただいています。<br/>
          　地域に密着した広告、特集号はもちろん、スポーツ月刊誌「Ｄａｓｈ」、女性をメインターゲットにした生活情報誌「chou･chou（シュシュ）」などの別刷り冊子も充実。企業、団体様のメッセージやビジョンを適格に伝える記事体広告の制作も積極的に行っています。幅広いジャンルの企画、多彩な媒体を持つデーリー東北だからこそ、スポンサー様のご要望にしっかりと応えることができます。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/advertisement" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="ad-flyer" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            折込広告（ちらし）
          </Typography>
          　折込広告は、新聞とともに毎日各家庭に配達される、安心で確実な媒体です。そこに盛り込まれる商品情報は、消費者にとって欠かすことのできない生活情報です。デーリー東北折込センターでは、当社新聞販売店網を活用し、ご希望の地域読者に速やかに確実にお届けします。また「新聞折込広告基準」に従い信頼される折込広告を心掛けております。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="/flyer" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={6}>
                <CustomButton href="/pdf/flyer/revision_2025flyer.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  2025年度折込広告部数改定について
                </CustomButton>
              </Grid>
              {/* 
              <Grid spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/flyer/2024orikomi_change-001.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    2024年４月 岩手県扱い折込料金改定のご案内
                  </CustomButton>
                </Grid>
              </Grid>
               */}
              {/* 
              <Grid spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/flyer/2024orikomi_oshirase-001.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    折込チラシ部数改定について
                  </CustomButton>
                </Grid>
              </Grid>
              */}
              {/* 
              <Grid spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/flyer/2024orikomi_oshirase-002.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    2024衆議院選挙に伴う折込広告不可日のお知らせ
                  </CustomButton>
                </Grid>
              </Grid>
              */}

            </Grid>
          </Box>
        </Box>

        <a id="ad-kyu-deli" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            求ーでり
          </Typography>
          八戸の求人紹介サイト 毎月第４日曜日更新！

          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              {/* 
              <Grid item xs={12} md={4}>
                <CustomButton href="https://www.q-delisunday.com/" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
              */}
              <Grid spacing={0} container direction="row" justify="center">
                <Grid item xs={12} md={4}>
                  <CustomButton href="/pdf/ad/kyu-deli-guide.pdf" className="px-4 m-2 d-block" size="large" themeColor={red}>
                    求ーでり料金表
                  </CustomButton>
                </Grid>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="ad-47club" className="anchor"></a>
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            47CLUB
          </Typography>
          　全国の1,300を超えるショップと47都道府県の地方新聞社が一緒になって活動をしています。
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="https://www.47club.jp/?cid=vc" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>

        <a id="ad-kanaeru" className="anchor"></a>
        <Box my={8}>
          <Grid spacing={0} container direction="row" justify="center">
            <Grid item xs={12} md={7}>
              <Typography className="font-weight-bold my-3" variant="h5" component="h2">
                「カナエルはちのへ」
              </Typography>
              　デーリー東北新聞社は２０１９年２月から、地域の未来を担う中学・高校生の職業観を育てる情報誌「カナエルはちのへ」を発行しています。<br/>
              　八戸圏域に事業所を置く企業・団体の協賛を得て制作し、学校を通じて八戸市内の中高生と三戸郡内の高校生全員に継続的に無償配布しています。地元企業や、そこで働く人の思いなどを紹介し、中高生が自分の将来について考えを深めるきっかけにしてもらうと同時に、地域経済を支える企業の人材確保を支援します。<br/>
              　Ａ４判、基本32ページ（創刊号28ページ）、オールカラー、年２回発行。個別の配布希望にはお応えできませんので、ご了承ください。<br/>
              　同誌の趣旨に賛同し、ご協賛いただける企業・団体を随時募集中です。申し込み、問い合わせ先は「カナエルはちのへ」協賛担当（地域ビジネス局）＝電話0178（80）7095、メールアドレスkanaeru@daily-tohoku.co.jp<br/>
            </Grid>
            <Grid item xs={12} md={5}>
              <Box p={2} textAlign="center">
                <img src="/images/kanaeru/kanaeru_vol11.jpg" className="img-fluid" />
              </Box>
            </Grid>
          </Grid>
        </Box>

        {/*
        <Box my={8}>
          <Typography className="font-weight-bold my-3" variant="h5" component="h2">
            まいぷれ はちのへ
          </Typography>
          　デーリー東北新聞社は地域密着型情報サイト「まいぷれ」を運営する株式会社フューチャーリンクネットワーク（本社・千葉県船橋市、石井丈晴代表取締役）とパートナー企業契約を結び、八戸市と近隣町村の情報を発信するサイト「まいぷれ はちのへ」を２０１７年３月１日オープンさせることになりました。<br/>
          　フューチャーリンクネットワークは２０１８年４月１日現在、１１１社のパートナー企業と契約、２４７エリア(４４都道府県､５８１市区町村）で｢まいぷれ｣の運営を行っている会社です。<br/>
          　「まいぷれ　はちのへ」は青森県南の情報を集め、編集し、インターネットを通じて皆さんへ情報発信することが事業の中心です。イベント・市民活動・商店に密着した情報を発信することで、地域経済活性化のお役に立てるように頑張ります。<br/>
          <Box my={4} textAlign="center">
            <Grid className="p-3" spacing={0} container direction="row" justify="center">
              <Grid item xs={12} md={4}>
                <CustomButton href="http://feature.daily-tohoku.co.jp/web2/mypl/mypl.html" className="px-4 m-2 d-block" size="large" themeColor={red}>
                  詳　細
                </CustomButton>
              </Grid>
            </Grid>
          </Box>
        </Box>
        */}

      </div>
    </div>
  );
}

export default Corporation;
